const RoutesToPages = {
  loginPage: "/",
  home: "/starting-page",
  preferences: "/preferences",
  favourites: "/favourites",
  contact: "/contact",
  terms: "/terms",
  recipe: "/recipe",
  singleRecipe: "/single-recipe/",
  policy: "/privacy-policy",
  myAccount: "/my-account",
  testResults: "/test-results",
};

export default RoutesToPages;
